import "./Home.module.css";
import IntestazioneTecnica from "@/reusable_sections/Header";
import InfrastrutturaInvisibile from "./sections/InfrastrutturaInvisibile";
import AccessMetric from "./sections/AccessMetric";
import SoluzioniSuMisura from "./sections/SoluzioniSuMisura";
import AnalisiMatematica from "./sections/AnalisiMatematica";
import CandidaturaOperativa from "./sections/CandidaturaOperativa";
import StartStrategicCollaboration from "./sections/StartStrategicCollaboration";
import PieDiPagina from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <IntestazioneTecnica />
      <InfrastrutturaInvisibile />
      <AccessMetric />
      <SoluzioniSuMisura />
      <AnalisiMatematica />
      <CandidaturaOperativa />
      <StartStrategicCollaboration />
      <PieDiPagina />
    </div>;
}